<div class="grid">
  <div class="col-12 p-md12">
    <div class="p-fluid formgrid grid User BlueBar">
      <form [formGroup]="userForm" class="col-12">
        <!--<div class="p-fluid formgrid grid col-12">-->
        <div class="p-fluid formgrid col-12 md:col-12">
          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> User Name: </label>
          </div>
          <div class="col-9 md:col-10">
            <div>{{ userForm.get('ehrUserName').value }}</div>
          </div>
        </div>

        <hr />

        <div class="p-fluid formgrid col-12 md:col-12">
          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> Login Name: </label>
          </div>
          <div class="col-9 md:col-10">
            <div>{{ userForm.get('loginId').value }}</div>
          </div>
        </div>

        <hr />

        <!--</div>-->

        <div class="p-fluid formgrid col-12" style="display: flex">
          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> Last Name: </label>
          </div>
          <div class="col-12 md:col-2 pl-0">
            <div>{{ userForm.get('lname').value }}</div>
          </div>

          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> First Name: </label>
          </div>
          <div class="col-12 md:col-2">
            <div>{{ userForm.get('fname').value }}</div>
          </div>

          <div class="col-12 md:col-2 bold" style="text-align: center">
            <label for="float-input"> MI: </label>
          </div>
          <div class="col-12 md:col-2">
            <div>
              {{
                userForm.get('mi').value === ('' || ' ')
                  ? '...'
                  : userForm.get('mi').value
              }}
            </div>
          </div>
        </div>

        <hr />
        <div class="p-fluid formgrid col-12 md:col-12">
          <div class="col-12 md:col-2 bold floatL" style="width: max-content">
            <label for="float-input"> Email Address: </label>
          </div>
          <div class="col-10 md:col-10">
            <div>{{ userForm.get('emailAddress').value }}</div>
          </div>
        </div>
        <hr />

        <div class="p-fluid formgrid col-12 md:col-12">
          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> Cell No: </label>
          </div>
          <div class="col-10 md:col-10">
            <div>{{ userForm.get('cellNo').value }}</div>
          </div>
        </div>
        <hr />

        <div class="p-fluid formgrid col-12 md:col-12">
          <div class="col-12 md:col-2 bold floatL">
            <label for="float-input"> Role: </label>
          </div>
          <div class="col-10 md:col-10">
            <div>{{ userForm.get('userRole').value }}</div>
          </div>
        </div>
        <hr />
      </form>
    </div>

    <!--<div class="card  blueGradient p-messagesp-messages-summary border-radius-5 ">
            <span style="font-size: 14px;">ORGANISATIONS: </span>
        </div>-->
  </div>
</div>
